import request from '../../../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comLoginNews/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const handleStatus = query => {  
    var list = request({
        url: 'comLoginNews/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comLoginNews/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comLoginNews/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDeleteMore = query => {  
    var list = request({
        url: 'comLoginNews/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comLoginNews/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const fetchSelect = query => {  
    var list = request({
        url: 'comLoginNews/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




